import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  loading: {
    left: 'calc(50% - 20px)'
  },

  img: {
    cursor: 'pointer'
  },

  pdf: {
    width: '60vw',
    height: '75svh',
    margin: '0 auto'
  },

  audio: {
    width: '40vw',
    height: '10svh'
  },

  video: {
    minWidth: '50vw',
    cursor: 'pointer'
  },
  footer: {
    paddingTop: '0.25rem'
  },

  footerBtn: {
    margin: '0 auto'
  },

  childrenClass: {
    maxHeight: '79svh'
  }
}))

export default useStyles
